import { customOptionValue } from "../wedding-party/constants";

export const presetRegistries = {
  Amazon: {
    title: "Amazon",
    url: "https://www.amazon.com/wedding/",
  },
  "Bed Bath & Beyond": {
    title: "Bed Bath & Beyond",
    url: "https://www.bedbathandbeyond.com/store/page/Registry",
  },
  "Bloomingdale's": {
    title: "Bloomingdale's",
    url: "https://www.bloomingdales.com/wedding-registry",
  },
  "Crate & Barrel": {
    title: "Crate & Barrel",
    url: "https://www.crateandbarrel.com/gift-registry/",
  },
  [customOptionValue]: {
    url: "",
  },
  "Macy's": {
    title: "Macy's",
    url: "https://www.macys.com/wedding-registry",
  },
  "MyRegistry.com": {
    title: "MyRegistry.com",
    url: "https://www.myregistry.com",
  },
  "Pottery Barn": {
    title: "Pottery Barn",
    url: "https://www.potterybarn.com/registry/",
  },
  Target: {
    title: "Target",
    url: "https://www.target.com/gift-registry/",
  },
  "West Elm": {
    title: "West Elm",
    url: "https://secure.westelm.com/registry/find-registry.html",
  },
  "Williams-Sonoma": {
    title: "Williams-Sonoma",
    url: "https://williams-sonoma.com/registry/",
  },
  Zola: {
    title: "Zola",
    url: "https://www.zola.com/find-registry",
  },
};

export const registrySelections = Object.keys(presetRegistries)
  .filter((key) => key !== "custom")
  .map((key) => ({
    text: key,
    value: key,
  }));

export const registrySelectionsWithCustom = Object.keys(presetRegistries).map(
  (key) => ({
    text: key === customOptionValue ? "Custom" : key,
    value: key,
  }),
);

// Birdie has a list of different types of registry types, but all this really does is change things
// like placeholder text the user sees when filling out their cash registry form.
export const CASH_REGISTRY_TYPES = {
  BABY_SHOWER: "Baby Shower",
  BAR_MITZVAH: "Bar Mitzvah",
  BIRTHDAY: "Birthday",
  BRIDAL_SHOWER: "Bridal Shower",
  GRADUATION: "Graduation",
  OTHER: "Other",
  WEDDING: "Wedding",
};
